import Mutations from '../../odata/mutations';

export default { ...new Mutations('interviewAnswer'), ...new Mutations('interviewAnswers') };
